export enum SurchargeTypeEnum {
  doplata = 1,
  rabat = 2
}
